import type { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import CalendarIcon from '@wix/da-ds/pkg/Icons/Calendar';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { DATE_FORMATS, formatDate } from '@wix/da-i18next/pkg/time/functions';

import s from './PlanExpiringNote.scss';

interface Props {
  endTimestamp: string | number;
}

const PlanExpiringNote: FC<Props> = ({ endTimestamp }) => {
  const { i18n } = useTranslation();
  return (
    <Heading className={s['root']}>
      {/* prettier-ignore */}
      <Trans i18nKey={'packagePicker.heroTable.header.expiring'}>
          Your Core plan is expiring on{' '}
          <span className={s['end-date']}>
            {formatDate(endTimestamp, DATE_FORMATS.Date.Short, i18n.language)}
          </span>
        </Trans>
      <CalendarIcon size={IconSize.SMALLER} className={s['calendar-icon']} />
    </Heading>
  );
};
PlanExpiringNote.displayName = 'PlanExpiringNote';

export default PlanExpiringNote;
